import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import CashFlowActions from '../../../../reducers/modules/report/cash-flow/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/cash-flow'

export default class CashFlowMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(CashFlowActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      CashFlowMiddleware.showOne(dispatch, params);
      dispatch(CashFlowActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(CashFlowActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(CashFlowActions.process());
          CashFlowMiddleware.showlist(dispatch, params);
        };
  }
  static showExcel(params){
    return (dispatch) => {
        dispatch(CashFlowActions.process());
        CashFlowMiddleware.beforeShowExcel(dispatch, params);
      };
  }

  static listing(params){
    return (dispatch) => {
        dispatch(CashFlowActions.process());
        CashFlowMiddleware.showlisting(dispatch, params);
      };
  }
  static reset(){
    return (dispatch) => {
        dispatch(CashFlowActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(CashFlowActions.view());
        CashFlowMiddleware.showOne(dispatch, params);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      CashFlowMiddleware.showHelper(dispatch,params);
      };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(CashFlowActions.beforePrint());
      CashFlowMiddleware.showPrint(dispatch, params);
    };
  }

  static showPrint(dispatch, params) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashFlowMiddleware.getToken()}`,
      },
      url: process.env.REST_URL +'report/cash-flow/print',
      responseType: "json",
      data:params
      // method: 'POST', 
      // headers: {
      //   'Content-Type': 'application/json',
      //   Authorization: `Bearer ${CashFlowMiddleware.getToken()}`
      // },
      // url: process.env.REST_URL +'report/cash-flow/print',
      // responseType: 'json',
      // params:params
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashFlowActions.print(response.data.result));
          console.log('response',response.data.result);
        }
      })
      .catch((error) => {
        CashFlowMiddleware.alertHendler(dispatch, error);
      });
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashFlowMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-work-sheet' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(CashFlowActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        CashFlowMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${CashFlowMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(CashFlowActions.list(response.data.result));
          }
        })
        .catch((error) => {
          CashFlowMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashFlowMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(CashFlowActions.list(response.data.result));
        }
      })
      .catch((error) => {
        CashFlowMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashFlowMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashFlowActions.view(response.data.result));
        }
      })
      .catch((error) => {
        CashFlowMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(CashFlowActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(CashFlowActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
